<template>
  <svg width="15" height="15" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.67695 8.11723L6.55863 4.99997L9.67695 1.88277C9.88379 1.67594 10 1.39541 10 1.10291C10 0.810402 9.88379 0.529878 9.67695 0.323045C9.47012 0.116213 9.1896 0 8.89709 0C8.60459 0 8.32406 0.116213 8.11723 0.323045L4.99997 3.44137L1.88277 0.323045C1.67594 0.116213 1.39541 0 1.10291 0C0.958073 0 0.81466 0.0285035 0.680851 0.083929C0.547042 0.139355 0.425458 0.220632 0.323045 0.323045C0.220632 0.425458 0.139355 0.547042 0.083929 0.680851C0.0285035 0.81466 0 0.958073 0 1.10291C0 1.39541 0.116213 1.67594 0.323045 1.88277L3.44137 4.99997L0.323045 8.11723C0.220632 8.21964 0.139355 8.34123 0.083929 8.47504C0.0285035 8.60885 0 8.75226 0 8.89709C0 9.1896 0.116213 9.47012 0.323045 9.67695C0.529878 9.88379 0.810402 10 1.10291 10C1.39541 10 1.67594 9.88379 1.88277 9.67695L4.99997 6.55863L8.11723 9.67695C8.32406 9.88379 8.60459 10 8.89709 10C9.1896 10 9.47012 9.88379 9.67695 9.67695C9.88379 9.47012 10 9.1896 10 8.89709C10 8.60459 9.88379 8.32406 9.67695 8.11723Z"
      fill="#2C2C2C"
    />
  </svg>
</template>

<script>
export default {
  name: 'CrossClose',
}
</script>

<style></style>
